module.exports = __webpack_public_path__ + "img/man_5.b4d59037.jpg";